import { render } from "./DamageEntry.vue?vue&type=template&id=2538a2a0&scoped=true"
import script from "./DamageEntry.vue?vue&type=script&lang=js"
export * from "./DamageEntry.vue?vue&type=script&lang=js"

import "./DamageEntry.vue?vue&type=style&index=0&id=2538a2a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2538a2a0"]])

export default __exports__